import { InjectionToken } from '@angular/core';

export const APP_ENVIRONMENT = new InjectionToken('APP_ENVIRONMENT');

export interface MfeAppConfig {
  /**
   * The name of the app in EA. Used in the authorization logic of the header.
   */
  name: string;
  /**
   * The hostname of the standalone app. Used by the Shell to download the resources for the MFE.
   */
  hostname: string;
  /**
   * Indicates if an app is the default app
   */
  isDefaultApp: boolean;
  /**
   * The path for the MFE in the Shell. This is also used as the key for the MFE. This should still have a value even if the MFE is loaded in the root path (i.e., by setting aliasHostNames)
   */
  path: string;
  title: string;
  color: IColor;
  order: number;
  outlet?: string;
  /**
   * A comma-delimited string array. If the current hostname matches any of these, the MFE will be loaded in the root path.
   * This can be removed in favor of isRootApp config, but this might be useful later on if the business decides to have different alias for each MFE.
   * This doesn't need to be set if isRootApp is true.
   */
  aliasHostNames?: string;
  /**
   * If true, the MFE will be loaded in the rooth path.
   * This can be used as an alternative to aliasHostNames
   */
  isRootApp?: boolean;
  /**
   * True if MFE has additional providers in the root injector
   */
  hasRootProviders?: boolean;
  applicationID: number;
}

interface IColor {
  primary: string;
  [key: string]: string;
}

export type AppEnvironment<T = object> = {
  baseUrl: string;
  apiUrl: string;
  var1: string;
  var2: string;
  authConfigPath: string;
  auth0ClientConfig: auth0ClientConfig;
  domain: string;
  clientId: string;
  authorizationParams: authorizationParams;
  userInactivityTimeout: number;
  userInactivityPollingInterval: number;
  appsTest: Record<string, string>;
  apps: Record<string, MfeAppConfig>;
  /**
   * If true, enables loading MFE in the root path of the Shell.
   */
  useRootPath: boolean;
  flags: {
    [K in 'disableAssetsInterceptorSW']: boolean;
  };
} & T;

export interface auth0ClientConfig {
  logDbOptions: logDbOptions;
  logoutRedirectUrl: string;
}

export interface logDbOptions {
  url: string;
  requestOptions: requestOptions;
}

export interface requestOptions {
  headers: headers;
}

export interface headers {
  'Content-Type': string;
}

export interface authorizationParams {
  audience: string;
  redirect_uri: string;
}
